import { render, staticRenderFns } from "./vip-holiday-gift.vue?vue&type=template&id=768682b2&scoped=true"
import script from "./vip-holiday-gift.vue?vue&type=script&lang=js"
export * from "./vip-holiday-gift.vue?vue&type=script&lang=js"
import style0 from "./vip-holiday-gift.vue?vue&type=style&index=0&id=768682b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768682b2",
  null
  
)

export default component.exports